import { render } from "./ProgressButton.vue?vue&type=template&id=83859b56&scoped=true"
import script from "./ProgressButton.vue?vue&type=script&lang=js"
export * from "./ProgressButton.vue?vue&type=script&lang=js"

import "./ProgressButton.vue?vue&type=style&index=0&id=83859b56&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-83859b56"]])

export default __exports__